import { PAGE_STATE_DURING_EVENT_MULTI_SESSION } from 'common/constants/virtualEvent';
import buildIDWithStateScope from 'common/compounds/VirtualEventBuilder/utils/buildIDWithStateScope';

function generateIdWithLivestreamStateScope(id) {
    return buildIDWithStateScope(id, PAGE_STATE_DURING_EVENT_MULTI_SESSION);
}

export const NODE_ID_VIRTUAL_CONTENT = generateIdWithLivestreamStateScope('virtualContent');
export const NODE_ID_EVENT_TITLE = generateIdWithLivestreamStateScope('eventTitle');
export const NODE_ID_SESSION_INFORMATION = generateIdWithLivestreamStateScope('sessionInformation');
export const NODE_ID_SPEAKER_INFORMATION = generateIdWithLivestreamStateScope('speakerInformation');
export const NODE_ID_LEAVE_BUTTON = generateIdWithLivestreamStateScope('leaveButton');
export const NODE_ID_UPCOMING_SESSIONS_BLOCK = generateIdWithLivestreamStateScope('upcomingSessionsBlock');
export const NODE_ID_UPCOMING_SESSIONS_HEADLINE = generateIdWithLivestreamStateScope('upcomingSessionsHeadline');
export const NODE_ID_UPCOMING_SESSIONS_PARAGRAPH = generateIdWithLivestreamStateScope('upcomingSessionsParagraph');
export const NODE_ID_UPCOMING_SESSION_CARDS = generateIdWithLivestreamStateScope('upcomingSessionCards');
export const NODE_ID_PAST_SESSIONS_BLOCK = generateIdWithLivestreamStateScope('pastSessionsBlock');
export const NODE_ID_PAST_SESSIONS_HEADLINE = generateIdWithLivestreamStateScope('pastSessionsHeadline');
export const NODE_ID_PAST_SESSIONS_PARAGRAPH = generateIdWithLivestreamStateScope('pastSessionsParagraph');
export const NODE_ID_PAST_SESSION_CARDS = generateIdWithLivestreamStateScope('pastSessionCards');
export const NODE_ID_SPEAKER_MODALS = generateIdWithLivestreamStateScope('speakerModals');
export const NODE_ID_FOOTER = generateIdWithLivestreamStateScope('footer');
export const NODE_ID_CONTACT_ORGANIZER_BUTTON = generateIdWithLivestreamStateScope('contactOrganizerButton');
export const NODE_ID_VISIT_EVENT_PAGE_BUTTON = generateIdWithLivestreamStateScope('visitEventPageButton');
export const NODE_ID_CUSTOM_BUTTON = generateIdWithLivestreamStateScope('customButton');
export const NODE_ID_CUSTOM_BUTTON_TWO = generateIdWithLivestreamStateScope('customButtonTwo');
export const NODE_DISPLAY_NAME_VIRTUAL_CONTENT = 'Virtual Content';
export const NODE_DISPLAY_NAME_EVENT_TITLE = 'Event Title';
export const NODE_DISPLAY_NAME_SESSION_INFORMATION = 'Session Information';
export const NODE_DISPLAY_NAME_SPEAKER_INFORMATION = 'Speaker Information';
export const NODE_DISPLAY_NAME_LEAVE_BUTTON = 'Button';
export const NODE_DISPLAY_NAME_UPCOMING_SESSIONS_BLOCK = 'Upcoming Sessions';
export const NODE_DISPLAY_NAME_UPCOMING_SESSIONS_HEADLINE = 'Headline';
export const NODE_DISPLAY_NAME_UPCOMING_SESSIONS_PARAGRAPH = 'Paragraph';
export const NODE_DISPLAY_NAME_UPCOMING_SESSION_CARDS = 'Upcoming Session Cards';
export const NODE_DISPLAY_NAME_PAST_SESSIONS_BLOCK = 'Past Sessions';
export const NODE_DISPLAY_NAME_PAST_SESSIONS_HEADLINE = 'Headline';
export const NODE_DISPLAY_NAME_PAST_SESSIONS_PARAGRAPH = 'Paragraph';
export const NODE_DISPLAY_NAME_PAST_SESSION_CARDS = 'Past Session Cards';
export const NODE_DISPLAY_NAME_SPEAKER_MODALS = 'Speaker Modals';
export const NODE_DISPLAY_NAME_FOOTER = 'Footer';
export const NODE_DISPLAY_NAME_CONTACT_ORGANIZER_BUTTON = 'Contact Organizer Button';
export const NODE_DISPLAY_NAME_VISIT_EVENT_PAGE_BUTTON = 'Visit Event Page Button';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON = 'Custom Button One';
export const NODE_DISPLAY_NAME_CUSTOM_BUTTON_TWO = 'Custom Button Two';
